
	import { Component, Prop, Vue, Watch } from "vue-property-decorator";
	import ApiHelper from "@/helpers/api-helper";
	import ServicesTypeService from "../../services/ServicesTypeService";

	/**
	 * Lo comparten «Servicios extra» (N-47) y Configuración. N-291 (T4): Configuración le pasa las
	 * opciones (`opciones`) de la lista que ya ha pedido, en vez de una petición por fila (eran 22 al
	 * abrir, y otra más con cada cambio); sin `opciones`, pide la suya como siempre.
	 */
	@Component({})
	export default class ExtraServiceTypeSelect extends Vue {
		@Prop({ default: null, required: false }) private extra_service_type_id;
		@Prop({ default: null, required: false }) private errors;
		@Prop({ default: null, required: false }) private opciones;
		@Prop({ default: null, required: false }) private excluir;
		@Prop({ default: undefined, required: false }) private rotulo;
		@Prop({ default: undefined, required: false }) private marcador;

		private items: any[] = [];
		private pagination: any = null;
		private filters: any = {};
		private type_id: any = null;
		private value = null;

		/** Las opciones, sin el propio tipo (no puede ir dentro de sí mismo). */
		get lista() {
			const todas = this.opciones || this.items;
			return this.excluir ? todas.filter((opcion) => opcion.id !== this.excluir) : todas;
		}

		@Watch("extra_service_type_id")
		extra_service_type_id_change(value: string, oldValue: string) {
			this.type_id = value;
			if (this.opciones) {
				this.value = value as any;
				return;
			}
			this.getSelectorList();
		}

		mounted() {
			if (this.extra_service_type_id) {
				this.type_id = this.extra_service_type_id;
			}
			if (this.opciones) {
				this.value = this.type_id;
				return;
			}
			this.getSelectorList();
		}

		getSelectorList() {
			ServicesTypeService.getSelectorList(this.pagination, this.filters)
				.then((res) => {
					if (res.status === 200) {
						this.items = res.data;
						this.value = this.type_id;
					}
				})
				.catch((error) => {
					ApiHelper.handleErrors(error, {}, this.$bus);
				});
		}
	}
